<script setup lang="ts">
import TheHeader from './components/TheHeader.vue'
import TheFooter from './components/TheFooter.vue'
import SearchInput from './components/SearchInput.vue'
import CookieConsent from './components/dialogs/CookieConsent.vue'
import { storeToRefs } from 'pinia';
import { useNotificationStore } from './store/notifications';

const notificationStore = useNotificationStore();
const { notification, visible } = storeToRefs(notificationStore);

const snackbarColor: Record<string, string> = {
  error: 'error',
  warning: 'warning',
  success: 'success',
  info: 'info',
};
</script>

<template>
  <v-app>
    <TheHeader />
    <v-main class="container">
      <router-view></router-view>
    </v-main>
    <TheFooter />
    <SearchInput />
    <CookieConsent />

    <v-snackbar
      v-model="visible"
      :color="snackbarColor[notification?.type ?? 'error']"
      :timeout="5000"
      location="bottom right"
      rounded="lg"
    >
      {{ notification?.message }}
      <template #actions>
        <v-btn variant="text" @click="notificationStore.dismiss()">Dismiss</v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<style scoped>
.container {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}
</style>